import { getExchangeRate } from "services";
import { useSelector } from "react-redux";
import {
  ETH,
  ETHX,
  SFRXETH,
  STETH,
  WETH,
  WSTETH,
} from "@config/contractsConfig";
import { useQuery } from "@tanstack/react-query";
import useDepositEstimate from "./useDepositEstimate";
import { formatNumber } from "utils";
import { MAX_FRACTION_DIGITS } from "@constants/common";

export type ERDataType = {
  exchangeRate: number | undefined;
};

const APPOVED_ERC20 = [ETHX, ETH, STETH, WETH, SFRXETH];

const useExchangeRate = (variant = "dapp") => {
  const { selectedERC20, selectedERC20Vault, selectedERC20YieldVault } =
    useSelector((state: any) => state.user);

  const { returns: wstETHExchangeRate } = useDepositEstimate("1");

  const getSelectedAsset = () => {
    if (variant === "vault") return selectedERC20Vault;
    if (variant === "yieldvault") return selectedERC20YieldVault;
    return selectedERC20;
  };
  const selected = getSelectedAsset();

  const exchangeRateWstETH = Number(wstETHExchangeRate)
    ? formatNumber(
        Number(1 / +wstETHExchangeRate),
        false,
        MAX_FRACTION_DIGITS,
        true
      )
    : null;

  const { data: exchangeRateData } = useQuery({
    queryKey: ["exchange-rate", selected],
    queryFn: async () => {
      const r = await getExchangeRate(selected);
      return r.data;
    },
    enabled: APPOVED_ERC20.includes(selected),
    refetchInterval: 10_000,
  });

  return {
    exchangeRate:
      selected === WSTETH ? exchangeRateWstETH : exchangeRateData?.value,
  };
};

export default useExchangeRate;
